module.exports = __webpack_public_path__ + "static/media/AgreeFisheries24.4922fa0f.jpg";